import React from 'react'
import PropTypes from 'prop-types'

import { Button, ButtonGroup } from 'react-bootstrap'
import { BooleanCreator, Types } from '@leverege/api-attributes'
import { Selector } from '@leverege/ui-elements'
import Util from './Util'

export default class BooleanEditor extends React.Component {

  static TYPE = BooleanCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.bool,
    focus : PropTypes.bool,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.onChange = Util.onChange.bind( this )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    return false
  }
  
  render() {
    const { attribute : attr, value } = this.props;
    if ( attr == null ) {
      return <div />
    }

    const cValue = null;
    const change = ( evt ) => { this.onChange( evt.value ) }
    if ( this.props.dropdown ) {
      return (
        <div>
          <Selector
            value={value === true || value === false ? value : null}
            values={Types.Boolean.values()} 
            onChange={change} />
        </div>
      ) 
    } 
    const hasValue = typeof this.props.value !== 'undefined'
    const trueStr = checkTrim( attr.trueDisplayValue, 'On' )
    const falseStr = checkTrim( attr.falseDisplayValue, 'Off' )
    const unsetStr = checkTrim( attr.unsetDisplayValue, 'Not Set' )
    return (
      <ButtonGroup>
        <Button bsStyle={value === true ? 'primary' : 'default'} onClick={() => this.onChange( true )}>{trueStr}</Button>
        <Button bsStyle={value === false ? 'primary' : 'default'} onClick={() => this.onChange( false )}>{falseStr}</Button>
        <Button bsStyle={hasValue && value == null ? 'primary' : 'default'} onClick={() => this.onChange( null )}>{unsetStr}</Button>
      </ButtonGroup>
    )
  }
}

function checkTrim( v, dVal ) {
  if ( v == null ) {
    return dVal
  }
  if ( typeof v === 'string' && v.trim().length == 0 ) {
    return dVal
  }
  return v
}
